import { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import DetailsView from "../../../components/Views/DetailsView/DetailsView";
import { useHistory, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { actions } from "../state/actions";
import { actions as commonActions } from "../../../store/actions";
import InputFrames from "../../../components/Frames/InputFrames";
import ChildPosAdd from "./ChildPosAdd";
import ChildPosEdit from "./ChildPosEdit";

const DecentralizedEdit = () => {
  const history = useHistory();
  const urlParams = useParams();
  const dispatch = useDispatch();
  const commonState = useSelector((state) => state.common);
  const state = useSelector((state) => state.posDecentralized);
  const [isDisabled, setIsDisabled] = useState(true);
  const menuState = useSelector((state) => state.menus);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [childPosAdd, setChildPosAdd] = useState({
    POSLegalName: "",
    POSStreet: "",
    POSStreetNumber: "",
    POSCity: "",
    POSDistrict: "",
    POS_StateSK: "",
    POSZipCode: "",
    POSTaxID: "",
    POS_TaxCategorySK: "",
    POSXCoordinate: "",
    POSYCoordinate: "",
    POSStatus: "A",
  });
  const pageName = "Pos Decentralized";
  const [error, setError] = useState({
    status: false,
    POSLegalName: "",
    POSStreet: "",
    POSStreetNumber: "",
    POSCity: "",
    POSDistrict: "",
    POS_StateSK: "",
    POSZipCode: "",
    POSTaxID: "",
    POS_TaxCategorySK: "",
    POSXCoordinate: "",
    POSYCoordinate: "",
  });

  useEffect(() => {
    dispatch(commonActions.setLoading(true));
    dispatch(actions.getPosDecentralizedById(urlParams.id));

    if (commonState.redirect) {
      dispatch(commonActions.setRedirect(false));
      history.push("/decentralized");
    }
  }, [commonState.redirect]);

  useEffect(() => {
    const readonly = menuState?.data?.readOnly?.[pageName] === 1 ? true : false;
    setIsReadOnly(readonly);
  }, [menuState?.data?.readOnly?.[pageName]]);

  const handleChangeField = ({ target: { name, value } }) => {
    dispatch(actions.setChilsPosEditForm({ name, value }));
    setIsDisabled(false);
    setError((previousState) => ({
      ...previousState,
      status: false,
      POSLegalName: "",
      POSStreet: "",
      POSStreetNumber: "",
      POSCity: "",
      POSDistrict: "",
      stateDescription: "",
      POSZipCode: "",
      POSTaxID: "",
      taxcategoryDescription: "",
      POSXCoordinate: "",
      POSYCoordinate: "",
    }));
  };

  const handleDropDownChangeAdd = (event, value, key, sk) => {
    setChildPosAdd((previousState) => ({
      ...previousState,
      [key]: value?.[sk] || "",
    }));
    setIsDisabled(false);
    setError((previousState) => ({
      ...previousState,
      status: false,
      POSLegalName: "",
      POSStreet: "",
      POSStreetNumber: "",
      POSCity: "",
      POSDistrict: "",
      POS_StateSK: "",
      POSZipCode: "",
      POSTaxID: "",
      POS_TaxCategorySK: "",
      POSXCoordinate: "",
      POSYCoordinate: "",
    }));
  };

  const handleDropDownChangeEdit = (event, val, name, sk, description) => {
    const value = val?.[sk] || "";
    dispatch(actions.setChilsPosEditForm({ name, value }));

    dispatch(
      actions.setChilsPosEditForm({
        name: description,
        value: val?.[description] || "",
      })
    );

    setIsDisabled(false);
    setError((previousState) => ({
      ...previousState,
      status: false,
      POSLegalName: "",
      POSStreet: "",
      POSStreetNumber: "",
      POSCity: "",
      POSDistrict: "",
      POS_StateSK: "",
      POSZipCode: "",
      POSTaxID: "",
      taxcategoryDescription: "",
      POSXCoordinate: "",
      POSYCoordinate: "",
    }));
  };

  const handleChildPosAdd = ({ target: { name, value } }) => {
    setChildPosAdd((previousState) => ({
      ...previousState,
      [name]: value,
    }));
    setIsDisabled(false);
    setError((previousState) => ({
      ...previousState,
      status: false,
      POSLegalName: "",
      POSStreet: "",
      POSStreetNumber: "",
      POSCity: "",
      POSDistrict: "",
      POS_StateSK: "",
      POSZipCode: "",
      POSTaxID: "",
      POS_TaxCategorySK: "",
      POSXCoordinate: "",
      POSYCoordinate: "",
    }));
  };

  const handleFormValidate = (data) => {
    const pattern = /^-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,13}/i;
    let valid = true;
    if (data.POSLegalName === "") {
      setError((previousState) => ({
        ...previousState,
        status: true,
        POSLegalName: "Legal Name cannot be empty",
      }));

      valid = false;
      return;
    }

    if (data.POSStreet === "") {
      setError((previousState) => ({
        ...previousState,
        status: true,
        POSStreet: "Street cannot be empty",
      }));
      valid = false;
      return;
    }

    if (data.POSStreetNumber === "") {
      setError((previousState) => ({
        ...previousState,
        status: true,
        POSStreetNumber: "Street number cannot be empty",
      }));
      valid = false;
      return;
    }

    if (data.POSCity === "") {
      setError((previousState) => ({
        ...previousState,
        status: true,
        POSCity: "City cannot be empty",
      }));
      valid = false;
      return;
    }

    if (data.POSDistrict === "") {
      setError((previousState) => ({
        ...previousState,
        status: true,
        POSDistrict: "District cannot be empty",
      }));
      valid = false;
      return;
    }

    if (data.POS_StateSK === "") {
      setError((previousState) => ({
        ...previousState,
        status: true,
        POS_StateSK: "State cannot be empty",
      }));
      valid = false;
      return;
    }

    if (data.POSZipCode === "") {
      setError((previousState) => ({
        ...previousState,
        status: true,
        POSZipCode: "Zip Code cannot be empty",
      }));
      valid = false;
      return;
    }
    if (data.POSTaxID === "") {
      setError((previousState) => ({
        ...previousState,
        status: true,
        POSTaxID: "Tax Id cannot be empty",
      }));
      valid = false;
      return;
    }
    if (data.POS_TaxCategorySK === "") {
      setError((previousState) => ({
        ...previousState,
        status: true,
        POS_TaxCategorySK: "Tax Category cannot be empty",
      }));
      valid = false;
      return;
    }
    // if (data.POSXCoordinate === "") {
    //   setError((previousState) => ({
    //     ...previousState,
    //     status: true,
    //     POSXCoordinate: "Coordinates cannot be empty",
    //   }));

    //   valid = false;
    //   return;
    // }

    if (!pattern.test(data.POSXCoordinate)) {
      setError((previousState) => ({
        ...previousState,
        status: true,
        POSXCoordinate: "Enter Valid Coordinates",
      }));

      valid = false;
      return;
    }

    // if (data.POSYCoordinate === "") {
    //   setError((previousState) => ({
    //     ...previousState,
    //     status: true,
    //     POSYCoordinate: "Coordinates cannot be empty",
    //   }));
    //   valid = false;
    //   return;
    // }

    if (!pattern.test(data.POSYCoordinate)) {
      setError((previousState) => ({
        ...previousState,
        status: true,
        POSYCoordinate: "Enter Valid Coordinates",
      }));

      valid = false;
      return;
    }
    return valid;
  };

  const handleFormSubmit = () => {
    const {
      POSSK,
      POS_EZDSK,
      EZDCode,
      POS_ParentPOSSK,
      POSLegalName,
      POSStreet,
      POSCity,
      POSDistrict,
      stateDescription,
      POSTaxID,
      taxcategoryDescription,
      POSStatus,
      POS_TaxCategorySK,
      POS_StateSK,
    } = state.decentralizedEdit;
    if (!POS_ParentPOSSK && handleFormValidate(childPosAdd)) {
      const payload = {
        ...childPosAdd,
        POSStreetNumber: +childPosAdd.POSStreetNumber,
        POSXCoordinate: +childPosAdd.POSXCoordinate,
        POSYCoordinate: +childPosAdd.POSYCoordinate,
        POSZipCode: +childPosAdd.POSZipCode,
        userId: commonState.userInfo.principalName,
        countrySk: commonState.userInfo.countrySk,
        POSSK,
        POS_EZDSK,
        EZDCode,
      };
      dispatch(actions.addChildPos(payload));
      dispatch(commonActions.setUpdated(true));
      return;
    }
    if (POS_ParentPOSSK && handleFormValidate(state.decentralizedEdit)) {
      const payload = {
        POSLegalName,
        POSStreet,
        POSCity,
        POSDistrict,
        stateDescription,
        POSTaxID,
        taxcategoryDescription,
        POS_StateSK,
        POS_TaxCategorySK,
        POSStatus,
        POSStreetNumber: +state.decentralizedEdit.POSStreetNumber,
        POSXCoordinate: +state.decentralizedEdit.POSXCoordinate,
        POSYCoordinate: +state.decentralizedEdit.POSYCoordinate,
        POSZipCode: +state.decentralizedEdit.POSZipCode,
        userId: commonState.userInfo.principalName,
        countrySk: commonState.userInfo.countrySk,
        POSSK,
        POS_EZDSK,
        EZDCode,
      };
      dispatch(actions.updateChildPos(payload));
      dispatch(commonActions.setUpdated(true));
      return;
    }
  };

  const handleFormCancel = () => {
    history.push("/decentralized");
  };

  return (
    <DetailsView
      heading={`${
        !state?.decentralizedEdit?.POS_ParentPOSSK
          ? " Add Child Pos"
          : "Edit Child Pos"
      } `}
      onSubmit={handleFormSubmit}
      onCancel={handleFormCancel}
      isDisabled={isDisabled}
    >
      {state?.decentralizedEdit &&
      Object.keys(state.decentralizedEdit).length > 0 &&
      !commonState.loading ? (
        <form className="details__view__body__form">
          <Grid container spacing={3}>
            {state?.decentralizedEdit?.POS_ParentPOSSK ? (
              <ChildPosEdit
                childPosInfo={state?.decentralizedEdit}
                handleChangeField={handleChangeField}
                error={error}
                handleDropDownChangeEdit={handleDropDownChangeEdit}
                readOnly={isReadOnly}
              />
            ) : (
              <ChildPosAdd
                childPosAdd={childPosAdd}
                handleChildPosAdd={handleChildPosAdd}
                error={error}
                childPosInfo={state?.decentralizedEdit}
                handleDropDownChangeAdd={handleDropDownChangeAdd}
                readOnly={isReadOnly}
              />
            )}
          </Grid>
        </form>
      ) : (
        <InputFrames />
      )}
    </DetailsView>
  );
};
export default DecentralizedEdit;
